<template>
  <div class="contents renraku-menu">
    <h2>会社連絡</h2>

    <div class="container">

      <template v-if="isLoading">
        <template v-if="!isError">
          <loading :message="'データ読み込み中...'"></loading>
        </template>
      </template>
      <template v-else>
        <div class="page-menu-items">
          <div class="menu">

            <template v-if="authStore.hasPermission(PermissionConst.RENRAKU_CREATE)">
              <div class="col-item">
                <router-link :to="{ name: RouterConst.RENRAKU_CREATE }">連絡作成</router-link>
                <p>会社連絡を作成します</p>
              </div>
            </template>

            <div class="col-item">
              <router-link :to="{name: RouterConst.RENRAKU_SEARCH}">連絡確認</router-link>
              <p>会社連絡を確認します</p>
            </div>

          </div>
        </div>

      </template>

    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useInit } from '@/composable/renraku/menulist';
import { RouterConst } from '@/const/Router';
import { useAuthStore } from '@/store/auth';
import { PermissionConst } from '@/const/Permission';

export default defineComponent({
  setup() {
    // 初期化処理
    const { isLoading, isError } = useInit();

    const authStore = useAuthStore()

    return {
      isLoading,
      isError,
      RouterConst,
      authStore,
      PermissionConst,
    }
  },
  components: {
  }
})

</script>

<style lang="scss" scoped>
@import "@scss/components/menu-items.scss";
</style>
